module.exports = __webpack_public_path__ + "img/eye-cros.5ddd1c6.svg";